import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-slave',
  templateUrl: './slave.component.html',
  styleUrls: ['./slave.component.scss']
})
export class SlaveComponent implements OnInit {

  data: any = [];
  records: any[] = [];

  constructor(
    private rest: RestService
  ) { 
    this.GetSlave();
    this.GetReport();
  }

  ngOnInit() {
    setInterval(function () { this.GetSlave(); this.GetReport(); }.bind(this), 60000);
  }

  GetSlave() {
    this.rest.GetSlave()
    .subscribe(
      (data) => {
        this.data = data['data'];
      });
  }

  Fixdb(database,opcion) {
    this.rest.PostFix(database, opcion).subscribe( (data) => {
      console.log(data);
    });
  }

  GetReport() {
    this.rest.GetReportDB().subscribe( (data) => {
      this.records = data['data'];
    });
  }

}
